import { render, staticRenderFns } from "./AbkVisualIdentificationForm.vue?vue&type=template&id=35425986&scoped=true&"
import script from "./AbkVisualIdentificationForm.vue?vue&type=script&lang=js&"
export * from "./AbkVisualIdentificationForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkVisualIdentificationForm.vue?vue&type=style&index=0&id=35425986&scoped=true&lang=scss&"
import style1 from "./AbkVisualIdentificationForm.vue?vue&type=style&index=1&id=35425986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35425986",
  null
  
)

export default component.exports